var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "booking-overview"
  }, [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BookingSelectList"
    }
  })], 1)]), _c('b-card', {
    attrs: {
      "title": "預約總覽"
    }
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('b-row', {
    staticClass: "mt-2 mb-3",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('b-col', {
    attrs: {
      "sm": "4",
      "lg": "3"
    }
  }, [_c('b-form-select', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "options": _vm.bookingPresetsOptions
    },
    model: {
      value: _vm.query.preset_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "preset_id", $$v);
      },
      expression: "query.preset_id"
    }
  })], 1), _c('b-col', {
    staticClass: "ml-2",
    attrs: {
      "sm": "4",
      "lg": "3"
    }
  }, [_c('AppDatePicker', {
    attrs: {
      "placeholder": "選擇日期"
    },
    on: {
      "input": _vm.handleDateChanged
    },
    model: {
      value: _vm.selectedDate,
      callback: function callback($$v) {
        _vm.selectedDate = $$v;
      },
      expression: "selectedDate"
    }
  })], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1-inner",
      modifiers: {
        "collapse-1-inner": true
      }
    }],
    staticClass: "flex-shrink-0 ml-2",
    attrs: {
      "variant": "link"
    }
  }, [_vm._v(" 進階搜尋"), _c('i', {
    staticClass: "fa fa-chevron-down ml-2"
  })]), _c('h6', {
    staticClass: "text-center mt-2 ml-auto"
  }, [_vm._v("預約筆數：" + _vm._s(_vm.fetchCount) + " / 總筆數：" + _vm._s(_vm.totalCount))])], 1), _c('b-collapse', {
    attrs: {
      "id": "collapse-1-inner"
    }
  }, [_c('div', {
    staticClass: "mt-2 mb-3 d-flex flex-column"
  }, [_c('AppMultiSelect', {
    staticClass: "mb-2",
    staticStyle: {
      "order": "0"
    },
    attrs: {
      "options": _vm.statusOptions,
      "disabled": _vm.showLoading || !this.query.preset_id
    },
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  }), _vm.showBranchSelect ? _c('AppSingleSelect', {
    staticClass: "mb-2",
    style: {
      order: _vm.deepGet(_vm.bookingPresetModel, 'wizardFieldOrder.branch', 1)
    },
    attrs: {
      "options": _vm.branchOptions,
      "disabled": _vm.showLoading || !this.checkPermission([_vm.consts.BOOKING_LIST_BRANCH])
    },
    on: {
      "input": _vm.handleBranchFilterChanged
    },
    model: {
      value: _vm.branch,
      callback: function callback($$v) {
        _vm.branch = $$v;
      },
      expression: "branch"
    }
  }) : _vm._e(), _vm.showStaffSelect ? _c('b-select', {
    staticClass: "mb-2",
    style: {
      order: _vm.deepGet(_vm.bookingPresetModel, 'wizardFieldOrder.staff', 2)
    },
    attrs: {
      "options": _vm.staffOptions,
      "disabled": _vm.showLoading || _vm.staffOptions.length <= 1
    },
    on: {
      "input": _vm.handleStaffFilterChanged
    },
    model: {
      value: _vm.query.staff_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "staff_id", $$v);
      },
      expression: "query.staff_id"
    }
  }) : _vm._e(), _vm.showServiceSelect ? _c('b-select', {
    staticClass: "mb-2",
    style: {
      order: _vm.deepGet(_vm.bookingPresetModel, 'wizardFieldOrder.service', 3)
    },
    attrs: {
      "options": _vm.serviceOptions,
      "disabled": _vm.showLoading
    },
    on: {
      "input": _vm.handleServiceFilterChanged
    },
    model: {
      value: _vm.query.service_id,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "service_id", $$v);
      },
      expression: "query.service_id"
    }
  }) : _vm._e()], 1)]), _vm.bookingPresetModel.maximumBookingSlotCount > 0 ? _c('BookingSeats', {
    attrs: {
      "time-periods": _vm.timePeriods,
      "staffs": _vm.staffs,
      "services": _vm.services,
      "bookings": _vm.bookingList,
      "maximum-booking-slot-count": _vm.bookingPresetModel.maximumBookingSlotCount,
      "preset-id": _vm.query.preset_id,
      "show-mode-selection": false,
      "enable-booking-creation": false,
      "cell-min-height": 60
    }
  }) : _c('div', {
    staticClass: "text-center p-4"
  }, [_c('p', {
    staticClass: "text-muted"
  }, [_vm._v("此預約設定檔未啟用「預約次數限制」")])])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }